<template>
  <div>
    <h2 class="font-weight-bold mb-4">Registration</h2>
    <b-form-group label="Phone Number:" label-for="phone">
      <b-form-input v-model="phone" id="phone" type="number" required placeholder="Enter number"></b-form-input>
    </b-form-group>
    <b-form-group label="Password:" label-for="password">
      <b-form-input id="password" type="password" required placeholder="Enter password"></b-form-input>
    </b-form-group>
    <b-form-group label="Email:" label-for="email">
      <b-form-input id="email" type="email" required placeholder="Enter email"></b-form-input>
    </b-form-group>
    <b-form-checkbox id="terms" name="terms">
      I have read, understood and accepted the
      <b-link to="/contacts/terms">General Conditions of Loan</b-link> and
      <b-link to="/contacts/privacy">Privacy Policy and Data Protections</b-link>
    </b-form-checkbox>
    <b-form-checkbox id="receives" name="receives">
      I would like to receive information on offers and promotions.
    </b-form-checkbox>
    <div class="d-flex justify-content-end mb-4 next">
        <button @click.prevent="$router.push('/registration/step-2')" type="submit">Next Step</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      disabled: true,
      phone: Number
    };
  },
};
</script>